require('ta-semantic-ui/semantic/dist/components/accordion.css');
require('ta-semantic-ui/semantic/dist/components/accordion.js');

import React, {Component} from 'react'


class generalContent extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    $(this.accordion)
      .accordion()
      ;
    }
  render() {
    return (
    <div className="ui styled floated fluid accordion" ref={(e) => this.accordion = e}>

        <div className="title">
            <i className="dropdown icon"></i>
                {this.props.data.system.title}
        </div>
        <div className="content">
            <p className="transition hidden">{this.props.data.system.text}</p>
            <p className="transition hidden">{this.props.data.system.control}</p>
        </div>

        <div className="title">
            <i className="dropdown icon"></i>
                {this.props.data.actions.title}
        </div>
        <div className="content">
            <p className="transition hidden">{this.props.data.actions.text}</p>
            <p className="transition hidden">{this.props.data.actions.control}</p>
        </div>

        <div className="title">
            <i className="dropdown icon"></i>
                {this.props.data.parties.title}
        </div>
        <div className="content">
            <p className="transition hidden">{this.props.data.parties.text}</p>
            <p className="transition hidden">{this.props.data.parties.control}</p>
        </div>

        <div className="title">
            <i className="dropdown icon"></i>
                {this.props.data.seats.title}
        </div>
        <div className="content">
            <p className="transition hidden">{this.props.data.seats.text}</p>
            <p className="transition hidden">{this.props.data.seats.control}</p>
        </div>

        <div className="title">
            <i className="dropdown icon"></i>
                {this.props.data.lists.title}
        </div>
        <div className="content">
            <p className="transition hidden">{this.props.data.lists.text}</p>
            <p className="transition hidden">{this.props.data.lists.control}</p>
        </div>

        <div className="title">
            <i className="dropdown icon"></i>
                {this.props.data.lists2.title}
        </div>
        <div className="content">
            <p className="transition hidden">{this.props.data.lists2.text}</p>
            <p className="transition hidden">{this.props.data.lists2.control}</p>
        </div>
        <div className="title">
            <i className="dropdown icon"></i>
                {this.props.data.lists3.title}
        </div>
        <div className="content">
            <p className="transition hidden">{this.props.data.lists3.text}</p>
            <p className="transition hidden">{this.props.data.lists3.control}</p>
        </div>

    </div>
    )
  }
}

export default generalContent






// WEBPACK FOOTER //
// ./src/components/custom/general-content/GeneralContent.js